import React from "react";
import { IoMdHelp } from "react-icons/io";
import { PrimaryButton } from "components/Buttons";
import { useHistory } from "react-router-dom";
import "./styles.sass";
export const HelpButton = ({ path }) => {
  const history = useHistory();

  return (
    <div className="help__button">
      <PrimaryButton
        modifiers={["icon"]}
        onClick={() => history.push(`/dashboard/${path}/help`)}
      >
        <IoMdHelp />
      </PrimaryButton>
    </div>
  );
};
